module.exports = __webpack_public_path__ + "img/组合_hint@2x.fff45e64.png";